import { Collapse, Descriptions, Typography } from "antd"
import { ReactComponent as PhoneIcon } from "assets/icons/phone.svg"
import { ReactComponent as CopyIcon } from "assets/icons/copy.svg"

import Loader from "components/loader"
import { useTranslation } from "react-i18next"
import { copieToClipboard } from "utils/copy-to-clipboard"
import { UseQueryResult } from "@tanstack/react-query"
import { IPresence } from "../../types"
import { useMemberRespondents } from "../../queries"

const { Text, Link } = Typography
const Respondents: React.FC<{
  member: UseQueryResult<IPresence["member"]>
}> = ({ member }) => {
  const { data, isLoading } = useMemberRespondents(member.data?.id!, {
    enabled: member.isFetched,
  })

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Collapse
          items={data?.map((item) => ({
            key: item.id,
            label: item.name,
            children: <PhoneItem data={item} />,
          }))}
        />
      )}
    </>
  )
}

export default Respondents

interface Props {
  data: { phone: string; mobile?: string; phone_other?: string }
}

export const PhoneItem: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation()
  return (
    <Descriptions
      items={[
        {
          key: "phone",
          label: (
            <div>
              <PhoneIcon style={{ marginRight: 10 }} />
              <Text strong>{t("labels.phone")}</Text>
            </div>
          ),
          children: data?.phone && (
            <div>
              <Link href={`tel:${data.phone}`}>{data.phone}</Link>
              <CopyIcon
                style={{ marginLeft: 10 }}
                onClick={() => copieToClipboard(data.phone)}
              />
            </div>
          ),
        },
        {
          key: "mobile",
          label: (
            <div>
              <PhoneIcon style={{ marginRight: 10 }} />
              <Text strong>{t("labels.mobile")}</Text>
            </div>
          ),
          children: data?.mobile && (
            <div>
              <Link href={`tel:${data.mobile}`}>{data.mobile}</Link>
              <CopyIcon
                style={{ marginLeft: 10 }}
                onClick={() => copieToClipboard(data.mobile!)}
              />
            </div>
          ),
        },
        {
          key: "other",
          label: (
            <div>
              <PhoneIcon style={{ marginRight: 10 }} />
              <Text strong>{t("labels.other", { count: 1 })}</Text>
            </div>
          ),
          children: data?.phone_other && (
            <div>
              <Link href={`tel:${data.phone_other}`}>{data.phone_other}</Link>
              <CopyIcon
                style={{ marginLeft: 10 }}
                onClick={() => copieToClipboard(data.phone_other!)}
              />
            </div>
          ),
        },
      ]}
    />
  )
}
